
import Alert from 'vux/src/components/alert/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Panel from 'vux/src/components/panel/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


import JsBridge from 'JsBridge'

export default {
name: 'GameCenterDialog',

directives: {
TransferDom
},
components: {
XDialog,
Panel,
Alert
},

data () {
return {
showHideOnBlur: true,
list: [],
showAlert: false
}
},

mounted () {
let url = '/gamecenter/list'
JsBridge.callHandler('loadingSuccess', null, null)

this.$axios.get(url).then(response => {
console.log(response.data)
for (let i = 0; i < response.data.length; i++) {
this.list.push({
id: response.data[i].id,
title: response.data[i].name,
src: response.data[i].icon,
serverState: response.data[i].serverState,
gameurl: response.data[i].url,
desc: 'maintaining...'
})
}
}).catch(function (err) {
console.log('axios' + err)
})
},

methods: {
onImgError (item, $event) {
console.log(item, $event)
},

onClickItem (item) {
console.log('onClickItem')

if (item.serverState === 0) {
let json = {'gameId': item.id.toString(), 'gameUrl': item.gameurl}
let jsonStr = JSON.stringify(json)
JsBridge.callHandler('inviteFriend', jsonStr)
console.log('jsonStr:' + jsonStr)
location.href = item.gameurl
} else {
console.log('游戏停服')
this.showAlert = true
}
},

onClickClose () {
console.log('关闭')
JsBridge.callHandler('finishWeb', null, null)
}
}
}



// WEBPACK FOOTER //
// ./src/components/GameCenterDialog.vue